import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AzureAuthService } from '../../services/azure-auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  isLoading = false;
  errorMessage = '';
  statusMessage = '';

  constructor(
    private router: Router,
    private azureAuthService: AzureAuthService,
  ) {}

  async ngOnInit(): Promise<void> {
    console.log('LoginComponent inicializado');

    // Verificar si el usuario ya está autenticado
    if (this.azureAuthService.isFullyAuthenticated()) {
      console.log('Usuario ya autenticado, redirigiendo a /app/chat');
      this.router.navigate(['/app/chat']);
    }
  }

  /**
   * Inicia sesión con Microsoft usando popup
   */
  async loginWithMicrosoft(): Promise<void> {
    try {
      this.isLoading = true;
      this.errorMessage = '';
      this.statusMessage = 'Abriendo ventana de Microsoft...';

      console.log('Iniciando login con Microsoft (popup)...');

      // Llamar directamente al servicio de Azure (usará popup)
      await this.azureAuthService.login();

      // Si llegamos aquí, el login fue exitoso
      console.log('Login exitoso, redirigiendo a /app/chat');
      this.router.navigate(['/app/chat']);
    } catch (error: any) {
      console.error('Error durante el login:', error);

      // Manejar diferentes tipos de errores
      if (error.errorCode === 'user_cancelled') {
        this.errorMessage = 'Inicio de sesión cancelado.';
      } else if (error.errorCode === 'popup_window_error') {
        this.errorMessage =
          'Error al abrir la ventana de Microsoft. Verifica que los popups no estén bloqueados.';
      } else {
        this.errorMessage =
          'Error al iniciar sesión con Microsoft. Por favor, intente nuevamente.';
      }

      this.statusMessage = '';
      this.isLoading = false;
    }
  }
}
